// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__9-WIx","icon":"SortAdornment_icon__3Fqwb","up":"SortAdornment_up__2I5m_","down":"SortAdornment_down__3NXUh","active":"SortAdornment_active__3bLvT"};